import { api } from "./api";

export const distributorListApi = (params) => {
  return api.get(`/manufacturer/distributor/list`, { params });
};
export const distributorOnboardListApi = (params) => {
  return api.get(`/manufacturer/distributor/onboarding-list`, { params });
};
export const distributorDetailApi = (params) => {
  return api.get(`/manufacturer/distributor/view`, { params });
};

export const distributorOrderDetail = (params) => {
  return api.get(`/manufacturer/distributor/order-details-view`, { params });
};

export const distributorEnableDisable = (params) => {
  return api.post(
    `/manufacturer/distributor/disable-enable-distributor`,
    JSON.stringify(params)
  );
};
export const distributorLinkApi = (params) => {
  return api.post(
    `/manufacturer/distributor/link-distributor`,
    JSON.stringify(params)
  );
};
export const LinkdistributorListApi = (params) => {
  return api.get(
    "/manufacturer/distributor/distributor-list",
    JSON.stringify(params)
  );
};
export const fetchDistributorDistrictsApi = (params) => {
  return api.get(`/manufacturer/distributor/list-districts`, { params });
};

export const editDistributorDistrictsApi = (params) => {
  return api.post(
    `/manufacturer/distributor/edit-districts`,
    JSON.stringify(params)
  );
};
export const sendMailApi = (params) => {
  return api.post(
    `/manufacturer/distributor/send-mail`,
    JSON.stringify(params)
  );
};
export const divisionsOptionsApi = (params) => {
  return api.get(`/manufacturer/distributor/division-list`, { params });
};
export const distributorCreateApi = (params) => {
  return api.post(`/manufacturer/distributor/create`, JSON.stringify(params));
};
